<template>
  <com-page>
    <com-search :columns="searchColumns"></com-search>
    <com-card>
      <com-finance-list :defaultParams="defaultParams"></com-finance-list>
    </com-card>
  </com-page>
</template>

<script>
export default {
  data() {
    return {
      defaultParams: {
        status: 4
      },
      searchColumns: [
        {
          label: '合伙人名称',
          prop: 'name',
          type: 'input'
        },
        {
          label: '提现时间',
          prop: 'date',
          type: 'date'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped></style>
